import React from 'react';

import {ChangeLogTimestampCell} from 'src/components/change-log';
import {UserLink} from 'src/components/links';
import {ServerResponseHandler} from 'src/components/server-response-handler';
import {Skeleton} from 'src/components/skeleton';
import {getUserLabel} from 'src/utils/getUserLabel';
import {toCapitalCase} from 'src/utils/toCapitalCase';

import FormSection from '@pb/kit-component-form-section';
import Loading from '@pb/kit-component-loading';
import {Body, Cell, Head, Row, Table} from '@pb/kit-component-table';


import {useGetChangeLog} from './useGetChangeLog';

type Props = {
    alertId: number,
};

export const ChangeLog = ({alertId}: Props) => {
    const {isLoading, loadingError, data} = useGetChangeLog({alertId});

    return (
        <Skeleton shown={isLoading} view={<Loading/>}>
            <ServerResponseHandler serverError={loadingError} smallView={true}>
                <FormSection headline="Audit Log">
                    <Table borderedGrid={true}>
                        <Head>
                            <Cell>Action Type</Cell>
                            <Cell>Initiator</Cell>
                            <Cell>Timestamp</Cell>
                            <Cell>Reason</Cell>
                        </Head>
                        <Body>
                            {data.length === 0 ? data.map(({action, adminUser, editAt, reason}, i) => (
                                <Row key={i}>
                                    <Cell>{toCapitalCase(action)}</Cell>
                                    <Cell>
                                        <UserLink
                                            userId={adminUser.userId}
                                            caption={getUserLabel(adminUser)}
                                            place="Platform Alert Builder Audti Log"
                                        />
                                    </Cell>
                                    <Cell>
                                        <ChangeLogTimestampCell timestamp={editAt}/>
                                    </Cell>
                                    <Cell>{reason}</Cell>
                                </Row>
                            )) : (
                                <Row>
                                    <Cell colSpan={4} className="text-align_center">No data to show</Cell>
                                </Row>
                            )}
                        </Body>
                    </Table>
                </FormSection>
            </ServerResponseHandler>
        </Skeleton>
    );
};
